import { Tag, MapPin, Clock, Package } from "lucide-react";

const CHIPS = [
  { label: "Cake Designs & Sizes", icon: Tag, action: "showCollections" },
  { label: "Delivery Cities", icon: MapPin, query: "Which cities do you deliver to?" },
  { label: "Delivery Slots", icon: Clock, query: "What delivery time slots are available?" },
  { label: "Packaging", icon: Package, query: "Tell me about your packaging and how the cake is delivered safely" },
];

export default function QuickChips({ onChipClick, onShowCollections }) {
  return (
    <div
      className="flex flex-wrap gap-2.5 justify-center mt-6 mb-4 animate-fade-in-up"
      style={{ animationDelay: "0.15s" }}
      data-testid="quick-chips-container"
    >
      {CHIPS.map((chip) => (
        <button
          key={chip.label}
          onClick={() => chip.action === "showCollections" ? onShowCollections() : onChipClick(chip.query)}
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm transition-all duration-200 cursor-pointer"
          data-testid={`chip-${chip.label.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <chip.icon className="w-4 h-4 text-gray-500" />
          {chip.label}
        </button>
      ))}
    </div>
  );
}
